import {Vue} from 'vue-property-decorator';
import VueRouter from 'vue-router';
import routes from './routes';
import {
  checkLogin,
  initState,
  changeDocTitle,
  notMallService,
  closeDimmedArea, openDimmedArea,
} from './hooks';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
});

router.beforeEach(closeDimmedArea);
router.beforeEach(checkLogin);
router.beforeEach(notMallService);
router.beforeEach(initState);
router.afterEach(openDimmedArea);
router.afterEach(changeDocTitle);

export default router;
